import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "./DocumentsTab.scss";
import { ReactComponent as FolderImg } from "../../../images/folder.svg";
import { ReactComponent as SelectedFolder } from "../../../images/selectedFolder.svg";
import { catchError } from "../../../utils/Utils";
import { AxiosError, AxiosResponse } from "axios";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import Service from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFile } from "@fortawesome/free-solid-svg-icons";
import FinSpinner from "../../../commonfields/FinSpinner";
import UploadFile from "./UploadFile";
import { BankUserContext } from "../../../bankUserContext";
import { FileData, getProductAndLocationModel } from "../../../models/ActionModel";
import { toast } from "react-toastify";
import ReactFileViewer from "../../../commonfields/ReactFileViewer";
import { fileFormatSupported } from "../../../utils/GeneralUtils";  //supported documents
import EllipsisTooltip from "../../../utils/EllipsisTooltip";

interface Category {
  name: string;
  displayName: string;
  order?: number;
  folderId: string;
  selected: boolean;
  uploadDocuments: boolean;
  payload: string;
  subCategory: string;
}
interface subCategory {
  name: string;
  displayName: string;
  order?: number;
  folderId: string;
  selected: boolean;
  uploadDocuments: boolean;
  payload: string;
  documents: string;
}



interface initialProps {
  refreshComponent: boolean;
  context: any;
}


interface DocumentsTabMainState {
  folderNames: Category[];
  folderNamesToShow: { id: string; displayName: string }[];
  selectedFolder: any;
  selectedTab: string;
  viewFile: boolean;
  documentsData: any;
  loader: boolean;
  selectedFile: any;
  selectedData: any;
  showButton: boolean;
  subFolderNamesToShow: any;
  subSelectedFolder: any;
  subSelectedFolderFiles: any;
  filesToShowSubselectedFolder: boolean;
}
interface subCategory {
  folderNames: subCategory[];
  folderNamesToShow: { id: string; displayName: string }[];
  selectedFolder: any;
  selectedTab: string;
  viewFile: boolean;
  documentsData: any;
  loader: boolean;
  selectedFile: any;
  selectedData: any;
  showButton: boolean;
}

class DocumentsTabMain extends Component<
  WithRouterProps<initialProps>,
  DocumentsTabMainState
> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;


  constructor(props: WithRouterProps<initialProps>) {
    super(props);
    this.state = {
      folderNames: [],
      folderNamesToShow: [],
      selectedFolder: "",
      selectedTab: "products",
      viewFile: false,
      documentsData: null,
      loader: false,
      selectedFile: null,
      selectedData: null,
      showButton: false,
      subFolderNamesToShow: [],
      subSelectedFolder: {},
      subSelectedFolderFiles: [],
      filesToShowSubselectedFolder: false
    };
    this.service = new Service();
  }

  settingPayload = (object: any) => {

    try {
      const payload = JSON.parse(object.payload);
      if (payload) {
        const info: any = {
          clinetId: this.props.params?.clientId,
          clientProductId: this.props.params?.clientProductsId,
          folderId: object.folderId
        };

        const filteredObj = Object.fromEntries(
          Object.entries(payload).filter(([_, value]) => value !== null)
        );
        const keys = Object.keys(payload).filter(m => payload[m] == null);

        const obj: any = {}
        keys.forEach(m => {
          Object.assign(obj, {
            [m]: info?.[m],
          })
        })
        const finalPayload = { ...filteredObj, ...obj }
        return finalPayload
      }
    } catch (error) {
      catchError(error, true);
    }

  }

  folderHandling = (folder: any) => {
    let selectedfolder = {};
    this.state.folderNames?.forEach((m: Category) => {
      if (m.folderId === folder.folderId) {
        m.selected = true;
        selectedfolder = m;
      } else {
        m.selected = false;
      }
    });

    const finalPayload = this.settingPayload(folder);

    // if (folder.uploadDocuments) {
    //   let data: any = {
    //     screen: "CustomerDetails",
    //     sections: "getClientProductDocuments",
    //     isJsonReturnObject: false,
    //     clinetId: this.props.params?.clientId,
    //     folderId: folder.folderId,
    //   };

    //   if (this.props.params?.clientProductsId) {
    //     data = {
    //       ...data,
    //       clientProductId: this.props.params?.clientProductsId,
    //     };
    //   }

    //   this.setState({ loader: true });
    //   this.service
    //     .getFoldersByProducts(finalPayload)
    //     .then((response: AxiosResponse<any>) => {
    //       if (response.data) {
    //         const folders: any = response?.data?.map(
    //           (m: any, index: number) => {
    //             return {
    //               id: m.documentId,
    //               displayName: m.documentName,
    //               delete: m.delete,
    //               clientProductDocumentId: m.clientProductDocumentId,
    //             };
    //           }
    //         );
    //         this.setState({
    //           folderNamesToShow: folders,
    //           selectedFolder: selectedfolder,
    //         });
    //       } else {
    //         this.setState({
    //           folderNamesToShow: [],
    //           selectedFolder: selectedfolder,
    //         });
    //       }
    //     })
    //     .catch((error: AxiosError) => {
    //       catchError(error, true);
    //     })
    //     .finally(() => {
    //       this.setState({ loader: false });
    //     });
    // } else {
    // let data: any = {
    //   screen: "Docusign View NDA",
    //   sections: "getDocuSignDocumentUrl",
    //   isJsonReturnObject: false,
    // };

    // if (this.props.params?.clientProductsId) {
    //   data = {
    //     ...data,
    //     clientProductId: this.props.params?.clientProductsId,
    //   };
    // }

    this.setState({ loader: true });
    this.service
      .getFoldersByProducts(finalPayload)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          const folders: any = response?.data?.map(
            (m: any, index: number) => {
              return { id: m.documentId, displayName: m.documentName || m.documentfolder, delete: m?.delete, ...m };
            }
          );
          this.setState({
            folderNamesToShow: folders,
            selectedFolder: selectedfolder,
            subSelectedFolder: {

            },
            subFolderNamesToShow: false,
            subSelectedFolderFiles: [],
            filesToShowSubselectedFolder: false
          });
        } else {
          this.setState({
            folderNamesToShow: [],
            selectedFolder: selectedfolder,
            subSelectedFolder: {

            },
            subFolderNamesToShow: false,
            subSelectedFolderFiles: [],
            filesToShowSubselectedFolder: false
          });
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
    // }
  };

  getDownloadAllButton = () => {
    this.setState({ loader: true });
    if (this.context?.bankuserDetails?.organization?.orgId && this.props.params?.clientProductsId) {
      const payload = {
        screen: "Client Details",
        sections: "getBtnsByClientDetails",
        orgId: this.context?.bankuserDetails?.organization?.orgId,
        clientProductId: this.props.params?.clientProductsId,
        isJsonReturnObject: true,
        roleId: this.context?.bankRolesData?.roleId
      };
      this.service
        .getBtnsByClientDetails(payload)
        .then((res) => {
          // if (res?.data[0]?.widgetType === "download_button") {
          //   this.setState({ showButton: true })
          // }
          if (res?.data) {
            const downloadAll = res?.data?.find((each) => each.widgetType === "download_button")?.widgetType
            if (downloadAll) this.setState({ showButton: true })
          }
        }

        )
        .catch((err) => catchError(err, true))
        .finally(() => { this.setState({ loader: false }) })
    }
  };



  componentDidMount(): void {
    this.sideBarFolderToShow();
    this.getDownloadAllButton()
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<DocumentsTabMainState>, snapshot?: any): void {
    if (prevProps.refreshComponent !== this.props.refreshComponent) {
      this.sideBarFolderToShow();
      this.setState({
        folderNamesToShow: [], selectedFolder: null, subSelectedFolder: {

        }, subFolderNamesToShow: false,
        subSelectedFolderFiles: [], filesToShowSubselectedFolder: false
      })
    }
  }


  uploadFiles = (values: any) => {
    if (this.context?.bankuserDetails?.organization?.orgId && values?.documentTemplate) {
      this.setState({ loader: true });
      const data = {
        orgId: this.context?.bankuserDetails?.organization?.orgId,
        clientId: this.props.params?.clientId,
        clientProductId: this.props.params?.clientProductsId,
        folderId: this.state?.selectedFolder?.folderId,
      };

      this.service
        .uploadFilesDCT(values?.documentTemplate, data)
        .then(() => {
          this.folderHandling(this.state.selectedFolder);

        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          setTimeout(() => {
            this.setState({ loader: false });
          }, 1000)

        })
        .finally(() => {
          setTimeout(() => {
            this.setState({ loader: false });
          }, 1000)

        });
    }
  };

  sideBarFolderToShow = () => {
    this.setState({ loader: true });
    const data = {
      screen: "CustomerDetails",
      sections: "getDocumentFolders",
      isJsonReturnObject: false,
    };

    this.service
      .getFoldersByProducts(data)
      .then((response: AxiosResponse<any>) => {
        const folderNames: Category[] = response?.data?.map(
          (m: any, index: number) => {
            return {
              name: m?.folderName,
              displayName: m?.folderName,
              order: index,
              folderId: m.folderId,
              selected: false,
              uploadDocuments: m?.uploadDocuments,
              payload: m.payload
            };
          }
        );

        this.setState({
          folderNames: folderNames

        });
        this.setState({ loader: false });
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        this.setState({ loader: false });
      });
  };

  setViewFile = () => {
    this.setState({ viewFile: !this.state.viewFile });
  };


  fileView = (fileData: any) => {
    this.setState({
      subSelectedFolder: {}
    })

    if (fileData?.id || fileData.document?.documentName) {
      this.setState({ loader: true, selectedData: fileData });
      this.service
        .getDocuments(fileData.document?.filePath || fileData?.id)
        .then((response: AxiosResponse<FileData>) => {
          if (fileFormatSupported(response.data.fileType)) {
            const documentObject = {
              fileName: response.data.fileName,
              fileType: response.data.fileType,
              uri: `${response.data.fileContent}`,
            };
            this.setState({ documentsData: documentObject, viewFile: true });
          } else {
            toast.error("FileView is not supported")
          }

        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          this.setState({ loader: false });
        });
    } else if (fileData?.documentsubfolderlist) {
      const data = JSON.parse(fileData.documentsubfolderlist);
      this.setState({
        subSelectedFolder: {
          displayName: fileData?.displayName,
          data
        },
        filesToShowSubselectedFolder: false,
        subSelectedFolderFiles: []
      })
    }

    else {

      try {
        const data = JSON.parse(fileData.customerdocuments);

        const folders: any = data?.map(
          (m: any, index: number) => {
            return { id: m.documents.documentId, displayName: m.documents.documentName, delete: m?.delete };
          }
        );


        this.setState({
          folderNamesToShow: folders,
          subFolderNamesToShow: false,
          subSelectedFolderFiles: [],
          filesToShowSubselectedFolder: false
        });
      } catch (error) {
        catchError(error, true);
      }

    }



  };
  downloadAllDocuments = () => {
    this.setState({ loader: true });
    const data = {
      orgId: this.context?.bankuserDetails?.organization?.orgId,
      clientId: this.props.params?.clientId,
      clientProductId: this.props.params?.clientProductsId,
    };

    const productandLocationData = {
      sections: "getProductAndLocationByCPId",
      screen: "CustomerDetails",
      clientProductId: this.props.params?.clientProductsId,
    };
    this.service.getProductAndLocationByCPId(productandLocationData).then((response: AxiosResponse<getProductAndLocationModel[]>) => {
      this.service
        .downloadAllDocuments(data.clientId, data.clientProductId)
        .then((res) => {
          if (res?.data) {
            const blob = new Blob([res.data], { type: "application/zip" });
            const downloadUrl = URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = downloadUrl;
            downloadLink.download = `${response?.data[0]?.businessName}-${response?.data[0]?.productName}${response?.data[0]?.account ? "-" + response?.data[0]?.account : ""}`;
            downloadLink.click();
          }
        })
        .catch((err) => catchError(err, true))
        .finally(() => this.setState({ loader: false }));
    }).catch((error: AxiosError) => {
      catchError(error, true)
    });

  };

  deleteFile = (document: any) => {
    if (document?.delete && document?.id) {
      this.setState({ loader: true })
      const data = {
        sections: "clientProductDocument",
        data: {
          clientProductDocumentId: document?.clientProductDocumentId,
        },
      };
      this.service
        .deleteFile(document.id, data)
        .then(() => {
          this.folderHandling(this.state.selectedFolder)
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          this.setState({ loader: false });
        });
    }
  };
  TooltipWrapper = (content: string = '') => {

    return (
      <div className="lable tooltip-container">
        <span className="title">
          {content.length > 16 ? content.substring(0, 16) + "..." : content}
        </span>


      </div>
    );
  };
  renderFiles = (files: any, cf: String) => {
    files = files.map((f: any) => {
      if (f.document && typeof f.document === 'string') {
        f.document = JSON.parse(f.document)
      }
      return f;
    })
    return <>{
      files?.map((m: any) => (
        <div className="file">

          <div
            className="fileContainer pdfSvg"

          >
            <div className="imagesContainer">
              {(m.id || m.document?.documentName) ?
                <FontAwesomeIcon icon={faFile}
                  key={m.id || m.document?.documentName}
                  onClick={() => this.fileView(m)}
                  className="pdfImg" title="" /> :
                <SelectedFolder
                  className="selectedFolderDocuments"
                  key={m.id}
                  onClick={() => this.fileView(m)}
                />}
              {m?.delete && !this.props.context.readOnlyMode && (
                <div
                  className="deleteContainer"
                  onClick={() => this.deleteFile(m)}
                >
                  <FontAwesomeIcon icon={faClose} />
                </div>
              )}
            </div>
            {/* <p className="fileName">{this.TooltipWrapper(m.displayName)}</p> */}
            <p className="fileName"><EllipsisTooltip text={m.displayName || m.document?.documentName} maxLine={14}></EllipsisTooltip></p>
          </div>
        </div>
      ))
    }</>
  }

  render() {
    const { documentsData } = this.state;

    return (
      <>
        {this.state.loader ? <FinSpinner /> : <></>}
        <div className="documentsContainer">
          <div className="documentsSideBar">
            <div>

              {this.state.folderNames.length > 0 ? (
                this.state?.folderNames.map((m: Category, index: number) => (
                  <div
                    key={index}
                    className={`d-flex mt-2 folderContainer ${m.selected && "selectedfolder"
                      }`}
                    onClick={() => this.folderHandling(m)}
                  >
                    {!m.selected ? <FolderImg /> : <SelectedFolder />}
                    <p className="folderName">{m.name}</p>
                  </div>
                ))
              ) : (
                <>
                  <div className="noRecordsContainer">
                    <p>No Documents</p>
                  </div>
                </>
              )}

              {
                this.state.showButton &&
                <button
                  className="decisionbutton"
                  onClick={() => this.downloadAllDocuments()}
                >
                  Download All
                </button>}

            </div>
          </div>
          <div className="documentsmainContainer">
            <div className="d-flex">
              {this.state.selectedFolder && <FolderImg />}
              <p className="selectedFolder">
                {this.state.selectedFolder?.displayName}
                {
                  this.state.subSelectedFolder?.displayName ? <> &gt; {this.state.subSelectedFolder?.displayName}</> : <></>
                }
              </p>
              {this.state.selectedFolder?.uploadDocuments && (
                <div className="justify-content-end">
                  {!this.props.context.readOnlyMode && <UploadFile uploadFiles={this.uploadFiles} />}
                </div>
              )}
            </div>
            <div className="documentsFilesContainer">
              {this.state.selectedFolder ? (
                (this.state.subSelectedFolder?.displayName && !this.state.filesToShowSubselectedFolder) ?
                  <>{
                    this.state.subSelectedFolder?.data?.map((sF: any) => {
                      return <div className="file">
                        <div
                          className="fileContainer pdfSvg"

                        >
                          <div className="imagesContainer">
                            {sF.documentsubfolder ?

                              <SelectedFolder
                                className="selectedFolderDocuments"
                                key={sF.documentsubfolder}
                                onClick={() =>
                                  this.setState({ filesToShowSubselectedFolder: true, subSelectedFolderFiles: sF.documentslist?.filter((d1: any) => d1.document) || [] })}

                              /> : <></>}
                            {sF?.delete && !this.props.context.readOnlyMode && (
                              <div
                                className="deleteContainer"
                                onClick={() => this.deleteFile(sF.documentslist)}                            >
                                <FontAwesomeIcon icon={faClose} />
                              </div>)}

                          </div>
                          {/* <p className="fileName">{this.TooltipWrapper(m.displayName)}</p> */}
                          <p className="fileName"><EllipsisTooltip text={sF.documentsubfolder} maxLine={14}></EllipsisTooltip></p>
                        </div>
                      </div>
                    })
                  }</>
                  : (this.state.filesToShowSubselectedFolder && this.state.subSelectedFolderFiles.length > 0) ? (
                    <>{this.renderFiles(this.state.subSelectedFolderFiles, 'subFolder')}</>
                  ) : (this.state.filesToShowSubselectedFolder && !this.state.subSelectedFolderFiles.length) ?
                    <div className="noRecordsContainer">
                      <p>No Files</p>
                    </div> : (this.state.folderNamesToShow.length > 0) ? (
                      <>{this.renderFiles(this.state.folderNamesToShow, 'mainFolder')}</>
                    ) : (
                      <div className="noRecordsContainer">
                        <p>No Files</p>
                      </div>
                    )
              ) : (
                <>
                  <div className="noRecordsContainer">
                    <p>No Folder Selected</p>
                  </div>
                </>
              )}
            </div>

          </div>
        </div>
        <div className="fileViewerModalContainer">
          <Modal
            className="generic-modal"
            isOpen={this.state.viewFile}
            toggle={this.setViewFile}
          >
            <ModalHeader toggle={this.setViewFile}>

              <div className="generic-modal-title">{this.state?.selectedData?.displayName || this.state?.selectedData?.document?.documentName}</div>
            </ModalHeader>
            <ModalBody>
              <div className="TC_fileView">
                {this.state.loader ? (
                  <FinSpinner />
                ) : (
                  // <FileViewer files={[documentsData]} disableHeader={true} />
                  <ReactFileViewer fileDocument={documentsData} />
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

export default withRouter<WithRouterProps<initialProps>>(DocumentsTabMain);
